import { logError } from "@/shared/logging/errors";
import { Ripple } from "@/shared/ui/Ripple";
import { getNativeAppVersion } from "@/shared/utils/androidNativeUtils";

import { TastierClient } from "@/app/TastierClient";
import { BaseController } from "@/app/controller/BaseController";
import { trans } from "@/app/localization/Trans";
import { Popup } from "@/app/ui/Popup";
import { QrPermalinkCodeScanner } from "@/app/ui/QrPermalinkCodeScanner";
import { UserMenu } from "@/app/ui/UserMenu";

export class AllocationController extends BaseController {
    private $head: JQuery;
    private qrScanner?: QrPermalinkCodeScanner;
    private isDisabled = false;
    private userMenu: UserMenu;

    constructor() {
        super("allocation");

        this.$head = $('<div class="head"><div class="title">' + trans.allocation.title + "</div></div>").appendTo(
            this.$view
        );

        this.userMenu = new UserMenu({
            excludeLeaveTable: true,
        }).appendTo(this.$head);

        const scrollable = $('<div class="scrollable" />').appendTo(this.$view);

        scrollable.append('<div class="logo" />');
        scrollable.append('<div class="headline">' + trans.allocation.headline + "</div>");
        scrollable.append('<div class="hint">' + trans.allocation.scanHint + "</div>");

        if (navigator.mediaDevices !== undefined && navigator.mediaDevices.getUserMedia !== undefined) {
            this.addScanQrCodeBtn(scrollable);
        }

        scrollable.append('<div class="disclaimer">' + trans.allocation.disclaimer + "</div>");
        scrollable.append('<div class="open-bill-hint">' + trans.allocation.doYouHaveOpenBill + "</div>");

        const nativeAppVersion = getNativeAppVersion();
        if (nativeAppVersion !== undefined && nativeAppVersion.length > 0) {
            $('<div class="native-app-version">' + nativeAppVersion + "</div>").appendTo(scrollable);
        }
    }

    private addScanQrCodeBtn(container: JQuery) {
        const scanQr = $('<button class="btn scan">' + trans.allocation.scanQrBtn + "</button>").appendTo(container);
        Ripple.bind(
            scanQr.click((e) => {
                e.preventDefault();
                if (this.isDisabled) {
                    return;
                }

                this.scanQr();
            })
        );
    }

    private scanQr() {
        if (this.qrScanner === undefined) this.qrScanner = new QrPermalinkCodeScanner();

        this.qrScanner.onCodeDetected = (code) => {
            TastierClient.context.allocateByPermalink(code).catch((ex) => {
                logError(ex);
                Popup.show(trans.allocation.allocationFailed, undefined, undefined, undefined, "allocFailed");
            });
        };

        this.qrScanner.start().catch((ex) => {
            logError(ex);
            Popup.show(trans.allocation.cameraFailed);
        });
    }

    //sets the view disabled while direct link is loading
    public setDisabled(isDisabled: boolean) {
        this.isDisabled = isDisabled;
    }

    protected onBecomeVisible() {}

    protected onBecomeInvisible() {}
}
